import React, { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setPreguntaActiva,
  setAnswer,
  getUsuario,
  setRespuesta,
} from "../actions";

// 1. Importamos Spinner y Alert
import { Container, Row, Col, Button, Spinner, Alert } from "react-bootstrap";

import { Instrumento } from "./Instrumento";

// 2. Función Utilitaria para Aleatoriedad
const obtenerSiguientePregunta = (todasLasPreguntas, respuestasActuales) => {
  const preguntasPendientes = todasLasPreguntas.filter(
    (pregunta) =>
      !respuestasActuales.some((r) => r.id_pregunta === pregunta.id_pregunta)
  );
  if (preguntasPendientes.length === 0) {
    return null;
  }
  const randomIndex = Math.floor(Math.random() * preguntasPendientes.length);
  return preguntasPendientes[randomIndex].id_pregunta;
};

const Pregunta206 = (props) => {
  const dispatch = useDispatch();

  // 3. Estados para control de carga y errores
  const [isSaving, setIsSaving] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const [values, setValues] = useState({ seleccionada: 0, evaluar: 0 });

  // (submitted no se usaba realmente en el render, pero lo dejamos por si acaso)
  const [submitted, setSubmitted] = useState(false);

  const preguntaActiva = useSelector((state) => state.preguntaActiva);
  const usuario = useSelector((state) => state.usuario);
  const ticket = useSelector((state) => state.ticket);

  // LOGICA VOLVER
  const HandleClickVolver = () => {
    dispatch(
      setPreguntaActiva({
        id_instrumento: 0,
        id_pregunta: 0,
        contador: 0,
        //respuestas206: [], // Limpiamos el historial al salir
      })
    );
  };

  if (values.evaluar === 1) return <Navigate to="/eval6" replace={true} />;

  if (preguntaActiva.id_instrumento === 0)
    return <Navigate to="/inicio" replace={true} />;

  const HandleClick1 = (val) => {
    setValues((values) => ({
      ...values,
      seleccionada: val,
    }));
    if (errorMsg) setErrorMsg(""); // Limpiar error al seleccionar
  };

  // LOGICA SIGUIENTE (ASYNC + RANDOM)
  const HandleClickSiguiente = async () => {
    setIsSaving(true);
    setErrorMsg("");

    try {
      // 1. Guardar en API (Esperamos respuesta)
      const _props = {
        token: "c3649ba4e3a81815",
        function: "SetRespuesta",
        params: {
          ticket: ticket.Ticket,
          id_proceso: 1,
          id_usuario: ticket.id_usuario,
          id_pregunta: preguntaActiva.id_pregunta,
          respuesta: values.seleccionada,
          respuesta_texto: "",
          respuesta_2: 0,
          respuesta_texto_2: "",
          respuesta_3: 0,
          respuesta_texto_3: "",
        },
      };

      await dispatch(setRespuesta(_props));

      // 2. Actualizar array local de respuestas (Upsert) para el Random
      const _respuesta = {
        id_pregunta: preguntaActiva.id_pregunta,
        respuesta: values.seleccionada,
      };

      // Usamos respuestas206 como convención de almacenamiento en Redux
      const currentRespuestas = preguntaActiva.respuestas206 || [];
      const existingIndex = currentRespuestas.findIndex(
        (item) => item.id_pregunta === _respuesta.id_pregunta
      );

      let updatedRespuestas;
      if (existingIndex >= 0) {
        updatedRespuestas = currentRespuestas.map((item, index) =>
          item.id_pregunta === _respuesta.id_pregunta
            ? { ...item, ..._respuesta }
            : item
        );
      } else {
        updatedRespuestas = [...currentRespuestas, _respuesta];
      }

      // 3. Buscar Instrumento para pasar preguntas a la función random
      const _instrumento = Instrumento.find(
        (el) => el.id_instrumento === preguntaActiva.id_instrumento
      );

      // 4. Calcular Siguiente ID
      const idSiguiente = obtenerSiguientePregunta(
        _instrumento.preguntas,
        updatedRespuestas
      );

      // Si es null (fin del juego), mantenemos el actual para no romper render
      const nextId =
        idSiguiente !== null ? idSiguiente : preguntaActiva.id_pregunta;

      // 5. Actualizar Redux
      dispatch(
        setPreguntaActiva({
          id_instrumento: preguntaActiva.id_instrumento,
          id_pregunta: nextId,
          contador: preguntaActiva.contador + 1,
          respuestas206: updatedRespuestas, // Guardamos historial
        })
      );

      // 6. Reset local
      setValues((values) => ({
        ...values,
        seleccionada: 0,
        instrucciones_visible: false,
      }));
    } catch (error) {
      console.error(error);
      setErrorMsg("Error al guardar respuesta. Intente nuevamente.");
    } finally {
      setIsSaving(false);
    }
  };

  const _instrumento = Instrumento.find((element) => {
    return element.id_instrumento === preguntaActiva.id_instrumento;
  });

  // Agregamos chequeo de seguridad (?.)
  const _preg = _instrumento?.preguntas.find((element) => {
    return element.id_pregunta === preguntaActiva.id_pregunta;
  });

  // VISTA FIN DEL TEST
  if (_instrumento.total_preguntas < preguntaActiva.contador || !_preg)
    return (
      <Container>
        <h1 className="mt-4">Fin de Test</h1>
        <hr />
        <Row>
          <Col>
            <p className="xz-texto-v ">Has finalizado este test.</p>
            <p className="xz-texto-v ">Sigue adelante !</p>
          </Col>
        </Row>
        <Row>
          <Col>
            <Button className="xz-btn-pregunta" onClick={HandleClickVolver}>
              Volver al Inicio
            </Button>
          </Col>
        </Row>
      </Container>
    );

  // BOTÓN CON SPINNER
  const avanzar_siguiente = () => {
    if (values.seleccionada > 0)
      return (
        <Col className="text-end">
          <Button onClick={HandleClickSiguiente} disabled={isSaving}>
            {isSaving ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />{" "}
                Guardando...
              </>
            ) : (
              "Avanzar a Siguiente Pregunta"
            )}
          </Button>
        </Col>
      );
  };

  const _opcion1_class =
    values.seleccionada === 1 ? "xz-btn-pregunta-5" : "xz-btn-pregunta-2";
  const _opcion2_class =
    values.seleccionada === 2 ? "xz-btn-pregunta-5" : "xz-btn-pregunta-2";
  const _opcion3_class =
    values.seleccionada === 3 ? "xz-btn-pregunta-5" : "xz-btn-pregunta-2";
  const _opcion4_class =
    values.seleccionada === 4 ? "xz-btn-pregunta-5" : "xz-btn-pregunta-2";
  const _opcion5_class =
    values.seleccionada === 5 ? "xz-btn-pregunta-5" : "xz-btn-pregunta-2";

  return (
    <Container>
      <Row>
        <Col>
          <h3 className="mt-4 xz-titulo1">
            Pregunta {preguntaActiva.contador} de {_instrumento.total_preguntas}
          </h3>
        </Col>
        <Col>
          <h3 className="mt-4 xz-titulo2 text-end">
            {_instrumento.nombre_instrumento}
          </h3>
        </Col>
      </Row>
      <hr />
      <p className="xz-pregunta4">
        A continuación encontrará situaciones y deberá escoger aquella
        alternativa que sienta que mejor representa lo que usted haría en esa
        situación ficticia.
      </p>
      <hr />

      {/* ESTRUCTURA VISUAL ORIGINAL MANTENIDA */}
      <Row>
        {/* Columna Izquierda: Texto */}
        <Col className="col-12 col-sm-6 xz-pregunta3">
          <p className="">{_preg.texto}</p>
        </Col>

        {/* Columna Derecha: Botones */}
        <Col>
          <Row>
            <Col>
              <Button
                className={_opcion1_class}
                onClick={() => HandleClick1(1)}
              >
                {_preg.alt1}
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <Button
                className={_opcion2_class}
                onClick={() => HandleClick1(2)}
              >
                {_preg.alt2}
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <Button
                className={_opcion3_class}
                onClick={() => HandleClick1(3)}
              >
                {_preg.alt3}
              </Button>
            </Col>
          </Row>
          {/* Nota: En tu código original solo mostrabas 3 botones, 
              aunque tenías clases para 4 y 5. Si necesitas los otros, agrégalos aquí. */}
        </Col>
      </Row>

      <hr className="mt-5" />

      {/* MENSAJE DE ERROR */}
      {errorMsg && (
        <Row className="mb-3">
          <Col>
            <Alert variant="danger">{errorMsg}</Alert>
          </Col>
        </Row>
      )}

      <Row>
        <Col className="col-3 text-start">
          <span
            className="xz-texto-nota"
            style={{ cursor: "pointer", textDecoration: "underline" }}
            onClick={HandleClickVolver}
          >
            Volver al Inicio
          </span>
        </Col>
        <Col>
          <p className="xz-texto-nota ">{avanzar_siguiente()}</p>
        </Col>
      </Row>
    </Container>
  );
};

export default Pregunta206;
